import { Get } from "./apiUtils";
const getThroughput = async (): Promise<any> => {
  const response = await Get(`/api/Dashboard/throughput`);
  const result = await response.json();
  return result;
};
const getCycleTime = async (): Promise<any> => {
  const response = await Get(`/api/Dashboard/cycletime`);
  return await response.json();
};
const getOrderList = async (
  body:any
): Promise<any> => {
  const response = await Get(`/api/Order/active?salesOrg=${body?.salesOrg}&pageNo=${body?.pageNo}&pageSize=${body?.pageSize}&keyword=${body?.keyword}&modality=${body?.modality}`);
  return await response.json();
};
export const dashboardApi = {
  getThroughput,
  getCycleTime,
  getOrderList
};

